import React from 'react';
import Avatar from './Avatar';
import { PlusIcon } from './icons';

/**
 * Raden med stories högst upp i flödet.
 *
 * Egen story först, sedan de med osett innehåll. Ringen runt bilden är
 * limegrön så länge det finns något man inte sett — det är hela signalen,
 * så den ska inte konkurrera med något annat i raden.
 */
export default function Stories({ groups, me, onOpen, onCreate }) {
  const mine = groups.find(group => group.isMe);
  const others = groups.filter(group => !group.isMe);

  return (
    <div className="stories">
      <button className="story" onClick={mine ? () => onOpen(mine) : onCreate}>
        <span className={mine && mine.hasUnseen ? 'story__ring story__ring--new' : 'story__ring'}>
          <Avatar src={me.profile_picture} name={me.username} />
          <span className="story__add" onClick={(e) => { e.stopPropagation(); onCreate(); }}>
            <PlusIcon size={13} />
          </span>
        </span>
        <span className="story__name">Din story</span>
      </button>

      {others.map(group => (
        <button key={group.userId} className="story" onClick={() => onOpen(group)}>
          <span className={group.hasUnseen ? 'story__ring story__ring--new' : 'story__ring'}>
            <Avatar src={group.picture} name={group.username} />
          </span>
          <span className="story__name">{group.username}</span>
        </button>
      ))}
    </div>
  );
}
